var React = require('react');

function QuoteInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"_","data-name":"“","d":"M24,26.906a8.12,8.12,0,0,1,.122-3.1c1.22-5.315,8.737-16.357,14.361-22.6,1.725-1.9,3.709-1.553,3.5,1.13C41.491,9.47,41,21.885,39.647,26.569a7.654,7.654,0,0,1-5.956,5.215A10.091,10.091,0,0,1,31.608,32C28.13,32,24.716,30.233,24,26.906Zm-23.9,0a8.1,8.1,0,0,1,.122-3.1c1.22-5.315,8.737-16.357,14.36-22.6,1.726-1.9,3.709-1.553,3.5,1.13-.494,7.14-.982,19.555-2.337,24.239a7.657,7.657,0,0,1-5.956,5.215A10.1,10.1,0,0,1,7.708,32C4.229,32,.816,30.233.1,26.906Z","transform":"translate(0)","fill":"#fff"}));
}

QuoteInline.defaultProps = {"width":"42","height":"32","viewBox":"0 0 42 32"};

module.exports = QuoteInline;

QuoteInline.default = QuoteInline;
